class ruleLiquidation {
    constructor(
        id,
        name,
        description,
        conceptId,
        costCenterId,
        threshold

    ) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.conceptId = conceptId;
        this.costCenterId = costCenterId;
        this.threshold = threshold;

    }
    static fromJson({
        reglaLiqId,
        nombre,
        descrip,
        conceptoId,
        csCostoId,
        umbral
    }) {
        return new ruleLiquidation(
            reglaLiqId,
            nombre,
            descrip,
            conceptoId,
            csCostoId,
            umbral

        );
    }
}
export default ruleLiquidation;
